//CA3Slice
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    CocaBySkipData: {
        totalCount: 0,
        page: 0,
        pageSize: 50,
        collectionName: "CocaSkips",
        data: [],
        loading: false,
        error: false,
        lastRefreshedDate: ''
    }
}

const cocaAnnual3Slice = createSlice({
    name: 'cocaAnnual3',
    initialState,
    reducers: {
        clearData: (state) => {
            state.CocaBySkipData = initialState.CocaBySkipData
        },
    },
    extraReducers: (builder) => {
    }
})

export const { clearData } = cocaAnnual3Slice.actions;
export default cocaAnnual3Slice.reducer